import { render, staticRenderFns } from "./submit.template?vue&type=template&id=4d91906f&lang=pug&"
import script from "./submit.client?vue&type=script&lang=ts&"
export * from "./submit.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d91906f')) {
      api.createRecord('4d91906f', component.options)
    } else {
      api.reload('4d91906f', component.options)
    }
    module.hot.accept("./submit.template?vue&type=template&id=4d91906f&lang=pug&", function () {
      api.rerender('4d91906f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/feedback/submit/submit.component.vue"
export default component.exports